module.exports = __webpack_public_path__ + "static/media/logo-small.92aaf674.webp";